import { createContext, useContext, useEffect, useMemo, useState } from "react";
import api from "@/lib/api";
import { setLanguage } from "@/i18n";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    if (window.location.pathname.startsWith("/share/")) {
      setUser(null);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(null));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data.user);
    return data.user;
  };

  const refreshUser = async () => {
    const { data } = await api.get("/auth/me");
    setUser(data);
    return data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      console.warn("logout request failed", e);
    }
    setUser(null);
  };

  useEffect(() => {
    if (user?.language) setLanguage(user.language);
  }, [user?.language]);

  const value = useMemo(() => ({ user, setUser, login, logout, refreshUser }), [user]);

  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
